import React from "react";
import { Card, Button, Row, Col } from "react-bootstrap";

interface WelcomeStepProps {
    onContinue: () => void;
}

const WelcomeStep: React.FC<WelcomeStepProps> = ({ onContinue }) => {
    return (
        <div className="welcome-step">
            <h2 className="step-title text-center mb-4">Welcome to Remote Care Services</h2>

            <p className="lead text-center mb-4">
                Get the healthcare you need without leaving home.
            </p>

            <div className="services-overview mb-5">
                <Row>
                    <Col md={4}>
                        <Card className="service-card h-100">
                            <Card.Body className="text-center">
                                <div className="icon-container mb-3">
                                    <i className="bi bi-capsule"></i>
                                </div>
                                <h4>Medication</h4>
                                <p>Order prescriptions online after provider approval</p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={4}>
                        <Card className="service-card h-100">
                            <Card.Body className="text-center">
                                <div className="icon-container mb-3">
                                    <i className="bi bi-clipboard2-pulse"></i>
                                </div>
                                <h4>Lab Testing</h4>
                                <p>Convenient at-home testing</p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={4}>
                        <Card className="service-card h-100">
                            <Card.Body className="text-center">
                                <div className="icon-container mb-3">
                                    <i className="bi bi-calendar-check"></i>
                                </div>
                                <h4>Office Visits</h4>
                                <p>Schedule in-person appointments at nearby facilities</p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>

            <div className="d-grid gap-2">
                <Button variant="primary" size="lg" onClick={onContinue} className="mt-4">
                    Get Started
                </Button>
            </div>
        </div>
    );
};

export default WelcomeStep;
